import { Link } from "react-router-dom";

export function NavLogo() {
  return (
    <Link to="/" className="flex items-center gap-2 group">
      <img
        src="/logo.png"
        alt="TodoAI"
        className="h-10 w-auto rounded-lg transform group-hover:scale-105 transition-transform duration-300"
      />
      <span className="text-2xl font-bold tracking-tight text-foreground">
        TodoAI
      </span>
    </Link>
  );
}
